// Schliesst den Login clientseitig ab: React-Query-Cache invalidieren und
// den tokenUser mit Zeitstempel (Konvention für den Session-Ablauf) in
// localStorage persistieren. Wird von allen Login-Pfaden geteilt (Passwort,
// Passkey, MFA-Verifikation); die Navigation bleibt beim Aufrufer, da sie
// je nach Kontext redirect() (Router-Action) oder navigate() ist.
export const persistLoginSession = (queryClient, tokenUser) => {
  queryClient.invalidateQueries();
  const userWithTimestamp = {
    ...tokenUser,
    timestamp: new Date().toISOString(),
  };
  localStorage.setItem('user', JSON.stringify(userWithTimestamp));
};
